import { post } from 'services/api';

/**
 * generateDemoSubmit
 * Posts project email and name to generateDemoSubmit
 */
export function generateDemoSubmit(email: string, projectName: string) {
  return post('/admin/generateDemoSubmitJson', { email, projectName });
}
